module.exports = __webpack_public_path__ + "img/sieckFinesseAdaptation1.c7768935.png";